module.exports = __webpack_public_path__ + "img/res1.c8c5b96a.png";